export default __webpack_public_path__ + "static/cercle_vicieux_uw_fr-2aad5cd819d7e46e0ef185ecfd3b16e5.mp4";